
//****VARIABLES****
//CUSTOM//*********************************

//Cache
let cache = {
    sessionID: '',
    productitle: 'Photo Print',
    productid: 33043245793332,
    details: {
        orientation: 'square',
        size: '6x6',
        frame: 'noframe',
        layout: 'classicsquare',
        tiles: []
    }
};

//Declare options for right menu
let designobj = {
  options: [
    {
      name: 'Size',
      icon: svgsize,
      description: 'Choose from our selection of print sizes. Changing the orientation alters the layout, you can adjust this in the layout tab.',
      variants: [
        {
                    name: 'Size',
                    id: 'size',
                    type: 'select',
                    variations: [
                        {
                            name: 'Orientation',
                            id: 'orientation',
                            options: [
                                {
                                    name: 'Square',
                                    value: 'square'
                                },
                                {
                                    name: 'Portrait',
                                    value: 'portrait'
                                },
                                {
                                    name: 'Landscape',
                                    value: 'landscape'
                                },
                            ]
                        },
                        {
                            name: 'Size',
                            id: 'size',
                            options: [
                                {
                                    name: '6" x 6"',
                                    value: '6x6',
                                    linked: 'square'
                                },
                                {
                                    name: '8" x 8"',
                                    value: '8x8',
                                    linked: 'square'
                                },
                                {
                                    name: '12" x 12"',
                                    value: '12x12',
                                    linked: 'square'
                                },
                                {
                                    name: '16" x 16"',
                                    value: '16x16',
                                    linked: 'square'
                                },
                                {
                                    name: '20" x 20"',
                                    value: '20x20',
                                    linked: 'square'
                                },
                                {
                                    name: '24" x 24"',
                                    value: '24x24',
                                    linked: 'square'
                                },
                                //Portrait
                                {
                                    name: '4" x 6"',
                                    value: '4x6',
                                    linked: 'portrait'
                                },
                                {
                                    name: '5" x 7"',
                                    value: '5x7',
                                    linked: 'portrait'
                                },
                                {
                                    name: '8" x 10"',
                                    value: '8x10',
                                    linked: 'portrait'
                                },
                                {
                                    name: '9" x 12"',
                                    value: '9x12',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '10" x 15"',
                                    value: '10x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 15"',
                                    value: '12x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 16"',
                                    value: '12x16',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '16" x 20"',
                                    value: '16x20',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '18" x 24"',
                                    value: '18x24',
                                    linked: 'portrait'
                                },
                                {
                                    name: '20" x 30"',
                                    value: '20x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 30"',
                                    value: '24x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 36"',
                                    value: '24x36',
                                    linked: 'portrait'
                                },
                                //Landscape
                                {
                                    name: '6" x 4"',
                                    value: '6x4',
                                    linked: 'landscape'
                                },
                                {
                                    name: '7" x 5"',
                                    value: '7x5',
                                    linked: 'landscape'
                                },
                                {
                                    name: '10" x 8"',
                                    value: '10x8',
                                    linked: 'landscape'
                                },
                                {
                                    name: '12" x 9"',
                                    value: '12x9',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 10"',
                                    value: '15x10',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 12"',
                                    value: '15x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: '16" x 12"',
                                    value: '16x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '20" x 16"',
                                    value: '20x16',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '24" x 18"',
                                    value: '24x18',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 20"',
                                    value: '30x20',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 24"',
                                    value: '30x24',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '36" x 24"',
                                    value: '36x24',
                                    linked: 'landscape'
                                },
                            ]
                        }
                    ]
                }
      ]
    },
    {
            name: 'Framing',
            icon: svgframe,
            description: 'Choose from our selection of frame finishes.',
            variants: [
                {
                    name: 'Frame',
                    id: 'frame',
                    type: 'select',
                    variations: [
                        {
                            name: 'Frame',
                            id: 'frame',
                            options: [
                                {
                                    name: 'No Frame',
                                    value: 'noframe'
                                },
                                {
                                    name: 'Matt Black',
                                    value: 'mattblack'
                                },
                                {
                                    name: 'Matt Silver',
                                    value: 'mattsilver'
                                },
                                {
                                    name: 'Brushed Copper',
                                    value: 'brushedcopper'
                                },
                                {
                                    name: 'Brushed Champagne Gold',
                                    value: 'brushedchampagnegold'
                                },
                                {
                                    name: 'Brushed Steel',
                                    value: 'brushedsteel'
                                },
                                {
                                    name: 'Polished Silver',
                                    value: 'polishedsilver'
                                },
                                {
                                    name: 'Polished Dark Grey',
                                    value: 'darkpolishedgrey'
                                },
                                {
                                    name: 'Black Oak',
                                    value: 'blackoak'
                                },
                                {
                                    name: 'White Oak',
                                    value: 'whiteoak'
                                },
                                {
                                    name: 'Oak',
                                    value: 'oak'
                                },
                                {
                                    name: 'Wenge',
                                    value: 'wenge'
                                },
                            ]
                        },
                    ]
                }
            ]
        },
    {
            name: 'Layout',
            icon: svglayout,
            description: 'Select a design layout from the options below, these change depending on orientation of the print.',
            variants: [
                {},
                {
                    name: 'Layout',
                    id: 'layout',
                    type: 'radio',
                    variations: [
                        //square
                        {
                            name: 'Classic',
                            value: 'classicsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Traditional',
                            value: 'traditionalsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Modern',
                            value: 'modernsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        //portrait
                        {
                            name: 'Classic',
                            value: 'classicportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g id="_3x3" serif:id="3x3" transform="matrix(1,0,0,1,57.744,-5.68434e-14)"> <g transform="matrix(0.492714,0,0,0.492714,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,35.2405,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,35.2405,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> </g> <g id="Square"> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Traditional',
                            value: 'traditionalportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g id="_3x3" serif:id="3x3" transform="matrix(1,0,0,1,57.744,-5.68434e-14)"> <g transform="matrix(0.492714,0,0,0.492714,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,35.2405,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,35.2405,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> </g> <g id="Square"> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Modern',
                            value: 'modernportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        //Landscape
                        {
                            name: 'Classic',
                            value: 'classiclandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g id="_3x3" serif:id="3x3" transform="matrix(1,0,0,1,57.744,-5.68434e-14)"> <g transform="matrix(0.492714,0,0,0.492714,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,35.2405,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,35.2405,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> </g> <g id="Square"> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Traditional',
                            value: 'traditionallandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g id="_3x3" serif:id="3x3" transform="matrix(1,0,0,1,57.744,-5.68434e-14)"> <g transform="matrix(0.492714,0,0,0.492714,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,35.2405,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,35.2405,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,150.729)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.492714,0,0,0.492714,150.729,266.217)"> <rect x="0" y="0" width="200" height="200"/> </g> </g> <g id="Square"> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Modern',
                            value: 'modernlandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                    ]
                }
            ]
        },
    /*{
      name: 'Style',
      icon: svgpalette,
      description: 'Customise the design of the photo such as filters or adjustments.',
      variants: [
        {
          name: 'Filters',
          id: 'photofilters',
          type: 'photofilters',
          variations: [
            {
              name: 'No Filter',
              id: 'nofilter',
            },
          ]
        },
      ]
    },*/
  ]
};

//Design Templates
let layouttemplates = [
    //Square templates
    {
        name: 'Classic',
        id: 'classicsquare',
        value: 'classicsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0,
                left: 0,
                width: 1,
                height: 1
            }
        },
    },
    {
        name: 'Modern',
        id: 'modernsquare',
        value: 'modernsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.25,
                left: 0.25,
                width: 0.5,
                height: 0.5
            }
        },
    },
    {
        name: 'Traditional',
        id: 'traditionalsquare',
        value: 'traditionalsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.15,
                left: 0.15,
                width: 0.7,
                height: 0.7
            }
        },
    },
    //Portrait Templates
    {
        name: 'Classic',
        id: 'classicportrait',
        value: 'classicportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0,
                left: 0,
                width: 1,
                height: 1
            }
        },
    },
    {
        name: 'Modern',
        id: 'modernportrait',
        value: 'modernportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.25,
                left: 0.25,
                width: 0.5,
                height: 0.5
            }
        },
    },
    {
        name: 'Traditional',
        id: 'traditionalportrait',
        value: 'traditionalportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.15,
                left: 0.15,
                width: 0.7,
                height: 0.7
            }
        },
    },
    //Landscape Templates
    {
        name: 'Classic',
        id: 'classiclandscape',
        value: 'classiclandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0,
                left: 0,
                width: 1,
                height: 1
            }
        },
    },
    {
        name: 'Modern',
        id: 'modernlandscape',
        value: 'modernlandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.25,
                left: 0.25,
                width: 0.5,
                height: 0.5
            }
        },
    },
    {
        name: 'Traditional',
        id: 'traditionallandscape',
        value: 'traditionallandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.15,
                left: 0.15,
                width: 0.7,
                height: 0.7
            }
        },
    },
];